import { ApolloClient, InMemoryCache, createHttpLink } from '@apollo/client/core';
import { DefaultApolloClient } from '@vue/apollo-composable';
import { createBootstrap } from 'bootstrap-vue-next';
import { createApp } from 'vue';
import { createRouter, createWebHistory } from 'vue-router';

// bootstrap-vue-next
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css';

import RootApp from '~/App.vue';
import SafeHtml from '~/common/SafeHtml';
import routes from '~/routes';

const el = document.getElementById('app');
const vueData = JSON.parse(el.getAttribute('data'));

const httpLink = createHttpLink({
  uri: vueData.gitlabGraphqlUrl,
});

const apolloClient = new ApolloClient({
  link: httpLink,
  cache: new InMemoryCache(),
});

const router = createRouter({
  history: createWebHistory('/'),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }

    if (to.hash) {
      return { el: to.hash, behavior: 'smooth' };
    }

    return { top: 0 };
  },
});
const bootstrap = createBootstrap({ directives: true });

createApp(RootApp)
  .provide(DefaultApolloClient, apolloClient)
  .provide('vueData', vueData)
  .use(router)
  .use(bootstrap)
  .directive('safe-html', SafeHtml)
  .mount('#app');
